import {ResizeHelper} from "../helpers/resize-helper"
import {Utils} from "../utils"

export class TeamOverview{
    private static categories: HTMLCollection;
    private static links: HTMLCollection;
    private static entries: HTMLCollection;
    private static filteredElement: Element;
    public static headerBottomPosition:number = 100;
    private static resizeHelper:ResizeHelper;
    private static filterBar:HTMLElement;

    static init() {
        document.addEventListener('DOMContentLoaded', TeamOverview.onDocumentLoaded, false);
        TeamOverview.resizeHelper = new ResizeHelper(TeamOverview.resizeFinished);
    }
    
    private static onDocumentLoaded() {
        TeamOverview.filterBar = document.getElementById("filterBar") as HTMLElement;
		var mainMenu = document.getElementById("nav_mainMenuWrapper");
		if(TeamOverview.filterBar != null && mainMenu != null){
			TeamOverview.headerBottomPosition = mainMenu.offsetTop + mainMenu.clientHeight + TeamOverview.filterBar.clientHeight;;
		}	
        TeamOverview.categories = document.getElementsByClassName('_category');
        window.addEventListener("scroll", TeamOverview.onScroll);
        for(var i=0; i<TeamOverview.categories.length; i++){
            var categoriesLinks = TeamOverview.categories.item(i).getElementsByTagName('a');
            for(var x =0; x<categoriesLinks.length; x++){
                categoriesLinks.item(x).addEventListener('click', TeamOverview.changeActiveCategory);
            }            
        }
        
        TeamOverview.entries = document.getElementsByClassName('_entryTitle');
        TeamOverview.links = document.getElementsByClassName('_category');
        TeamOverview.filteredElement = document.getElementsByClassName('_activeCategory')[0];

        TeamOverview.setFirstCategoryActive();
        TeamOverview.resizeFinished();
        
    }
    
    private static setFirstCategoryActive(){
        TeamOverview.categories[0].classList.add('active');
        TeamOverview.filteredElement.innerHTML = TeamOverview.entries[0].innerHTML;
    }

    private static changeActiveCategory(event: MouseEvent){
        var target = <HTMLElement>event.target;
        TeamOverview.resetActive(target)
    }

    private static resetActive(target:HTMLElement){
        for(var i=0; i<TeamOverview.categories.length; i++){
            TeamOverview.categories.item(i).classList.remove('active');           
        }
        if(target.parentElement != null){
            target.parentElement.classList.add('active');
        }
    }

    private static onScroll(){
        TeamOverview.checkMenuForActive();

    }
    public static checkMenuForActive(){
		if(TeamOverview.entries != null){
			for(var i = 0; i < TeamOverview.entries.length; i++){
                var element = <HTMLElement>TeamOverview.entries.item(i);

                if(element.previousElementSibling != null && element.previousElementSibling.classList.contains('_entryTitleAnchor')){
                    element = <HTMLElement>element.previousElementSibling;      
                } 

                var scroll = window.pageYOffset;        
                var elPosition = 0;
                if(element.closest('._contentsectionWrapper') != null){ 
                    // wordpress content anchor is set on content and not on title
                    if(element.parentElement != null){
                        element = element.parentElement;
                    }
                    if(element.parentElement != null){
                        element = element.parentElement;
                    }
                    if(element.parentElement != null){
                        element = element.parentElement;
                    }
                    if(element.parentElement != null){
                        element = element.parentElement;
                    }
                    elPosition = element.offsetTop;
                }else{
                    elPosition = element.offsetTop- element.clientTop;
                }
                if(elPosition > scroll){
					break;
                }
                TeamOverview.setActive(element.id);
				
			}
		}
    }
    private static setActive(title:string){        
        for(var i = 0; i < TeamOverview.links.length;i++){
            var element = <HTMLLinkElement>TeamOverview.links[i].firstElementChild; 
            if(element != null){
                if(TeamOverview.getHash(element.href).trim() === title.trim()){
                    TeamOverview.resetActive(element);
                    TeamOverview.filteredElement.innerHTML = element.innerHTML;
                    break;
                }
            }
        }
    }

    private static getHash(href: string): string{
        return href.split("#")[1];
    }
    
    private static resizeFinished(){
        if(Utils.desktopFlexMinSize > window.innerWidth){
            TeamOverview.filterBar.classList.toggle("_docked",true);
        }
    }
}